import {AppEinstellungenMobileComponent} from './home-layout/app-einstellungen/app-einstellungen-mobile/app-einstellungen-mobile.component';
import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {DashboardComponent} from './home-layout/dashboard/dashboard.component';
import {HomeLayoutComponent} from './home-layout/home-layout.component';
import {ObjekteComponent} from './home-layout/objekte/objekte.component';
import {PendenzenComponent} from './home-layout/pendenzen/pendenzen.component';
import {TerminComponent} from './home-layout/termin/termin.component';
import {BenutzerAnmeldungComponent} from './benutzer-anmeldung/benutzer-anmeldung.component';
import {AppEinstellungenComponent} from './home-layout/app-einstellungen/app-einstellungen.component';
import {ZeitenComponent} from './home-layout/service-app/zeiten/zeiten.component';
import {RapportPositionenComponent} from './home-layout/service-app/rapport-positionen/rapport-positionen.component';
import {RapportComponent} from './home-layout/service-app/rapport/rapport.component';
import {ServiceAppComponent} from './home-layout/service-app/service-app.component';
import {AgendaComponent} from './home-layout/service-app/agenda/agenda.component';
import {DocsComponent} from './home-layout/service-app/docs/docs.component';
import {PicsComponent} from './home-layout/service-app/pics/pics.component';
import {AuftraegeComponent} from './home-layout/service-app/auftraege/auftraege.component';
import {CalendarComponent} from './home-layout/pendenzen/calendar/calendar.component';
import {MeineTermineComponent} from './home-layout/meine-termine/meine-termine.component';
import {PersonalTasksComponent} from './home-layout/meine-aufgaben/personal-task.component';
import {MeineNotizenComponent} from './home-layout/meine-notizen/meine-notizen.component';
import {TimeAppComponent} from './time-app/time-app.component';
import {SettingsComponent} from './time-app/settings/settings.component';
import {SavedWorktimesComponent} from './time-app/saved-worktimes/saved-worktimes.component';
import {GalleryComponent} from './time-app/gallery/gallery.component';
import {ShareOrderComponent} from './time-app/share-order/share-order.component';
import {ShareEmpOrderComponent} from './time-app/share-emp-order/share-emp-order.component';
import {ScanComponent} from './time-app/scan/scan.component';
import {EditImgComponent} from './time-app/edit-img/edit-img.component';
import {ObjekteMobileComponent} from './home-layout/objekte/objekte-mobile/objekte-mobile.component';
import {AdressenMobileComponent} from './home-layout/adressen/adressen-mobile/adressen-mobile.component';
import {TerminMobileComponent} from './home-layout/termin/termin-mobile/termin-mobile.component';
import {DashboardMobileComponent} from './home-layout/dashboard/dashboard-mobile/dashboard-mobile.component';
import {DBControlComponent} from './home-layout/app-einstellungen/dbcontrol/dbcontrol.component';
import {PDFViewerComponent} from './pdfviewer/pdfviewer.component';
import {TimeAppDocumentsComponent} from './time-app/time-app-documents-component/time-app-documents.component';
import {TimeAppWorkSupplyManagementComponent} from './time-app/time-app-material/time-app-work-supply-management.component';
import {TimeAppWorkSupplyListComponent} from './time-app/time-app-material/time-app-work-supply-list/time-app-work-supply-list.component';
import {TimeAppWorkSupplyEntryComponent} from './time-app/time-app-material/time-app-work-supply-entry/time-app-work-supply-entry.component';
import {AddressOverviewComponent} from './home-layout/adressen/address-overview/address-overview.component';

import {AuthenticatedGuard} from './guards/authenticatedGuard';
import {NavigatorLicenseGuardGuard} from './guards/navigator-license-guard.guard';
import {PendenzenDeviceGuard} from './guards/pendenzen-device.guard';
import {ServiceAppLicenseGuard} from './guards/serviceapp-license-guard.guard';
import {TimeAppLicenseGuard} from './guards/timeapp-license-guard.guard';
import {TimeAppPlusGuardGuard} from './guards/timeapp-plus-guard.guard';

const routes: Routes = [
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    {
        path: 'login',
        component: BenutzerAnmeldungComponent,
    },
    {
        path: 'login/:errstate',
        component: BenutzerAnmeldungComponent,
    },
    {
        path: 'login/:errstate/:errmsg',
        component: BenutzerAnmeldungComponent,
    },
    {
        path: 'pdfviewer/:id',
        component: PDFViewerComponent,
    },
    {
        path: '',
        component: HomeLayoutComponent,
        canActivate: [AuthenticatedGuard],
        children: [
            {
                path: 'dashboard',
                canActivate: [NavigatorLicenseGuardGuard],
                component: DashboardComponent,
            },
            {
                path: 'adressen',
                canActivate: [NavigatorLicenseGuardGuard],
                component: AddressOverviewComponent,
            },
            {
                path: 'adressen/:id',
                canActivate: [NavigatorLicenseGuardGuard],
                component: AddressOverviewComponent,
            },
            {
                path: 'objekte',
                canActivate: [NavigatorLicenseGuardGuard],
                component: ObjekteComponent,
            },
            {
                path: 'objekte/:id',
                canActivate: [NavigatorLicenseGuardGuard],
                component: ObjekteComponent,
            },
            {
                path: 'pendenzen',
                component: PendenzenComponent,
                canActivate: [NavigatorLicenseGuardGuard, PendenzenDeviceGuard],
                children: [
                    { path: '', redirectTo: 'kalender', pathMatch: 'full' },
                    { path: 'kalender', component: CalendarComponent },
                ],
            },
            {
                path: 'meinetermine',
                canActivate: [NavigatorLicenseGuardGuard],
                component: MeineTermineComponent,
            },
            {
                path: 'meineaufgaben',
                canActivate: [NavigatorLicenseGuardGuard],
                component: PersonalTasksComponent,
            },
            {
                path: 'meinenotizen',
                canActivate: [NavigatorLicenseGuardGuard],
                component: MeineNotizenComponent,
            },
            { // TODO 26-01-26 https://swissjira.atlassian.net/browse/EN-4392 check if removable
                path: 'termin',
                canActivate: [NavigatorLicenseGuardGuard],
                component: TerminComponent,
            },
            {
                path: 'serviceapp',
                canActivate: [ServiceAppLicenseGuard],
                component: ServiceAppComponent,

                children: [
                    {
                        path: 'saagenda',
                        component: AgendaComponent,
                    },
                    {
                        path: 'saauftraege',
                        component: AuftraegeComponent,
                    },
                    {
                        path: 'sapositionen',
                        component: RapportPositionenComponent,
                    },
                    {
                        path: 'sazeiten',
                        component: ZeitenComponent,
                    },
                    {
                        path: 'sarapport',
                        component: RapportComponent,
                    },
                    {
                        path: 'sadocs',
                        component: DocsComponent,
                    },
                    {
                        path: 'sadocs/:id',
                        component: DocsComponent,
                    },
                    {
                        path: 'sapics',
                        component: PicsComponent,
                    },
                ],
            },

            {
                path: 'appeinstellungen',
                component: AppEinstellungenComponent,
            },
            {
                path: 'dbcontrol',
                component: DBControlComponent,
            }
        ],
    },
    /* Zeiterfassungs-App */
    {
        path: 'timeapp',
        title: 'Swiss-Soft Time',
        canActivate: [AuthenticatedGuard, TimeAppLicenseGuard],
        component: TimeAppComponent,
    },
    {
        path: 'timeapp/gallery/:orderID',
        title: 'Swiss-Soft Time',
        canActivate: [AuthenticatedGuard, TimeAppLicenseGuard],
        component: GalleryComponent,
    },
    {
        path: 'timeapp/documents/:orderID',
        title: 'Swiss-Soft Time',
        canActivate: [AuthenticatedGuard, TimeAppLicenseGuard, TimeAppPlusGuardGuard],
        component: TimeAppDocumentsComponent,
    },
    {
        path: 'timeapp/supplies/:orderID/:pseudoOrderName',
        title: 'Swiss-Soft Time',
        canActivate: [AuthenticatedGuard, TimeAppLicenseGuard, TimeAppPlusGuardGuard],
        component: TimeAppWorkSupplyManagementComponent,
        children: [
            {path: '', redirectTo: 'supply-list', pathMatch: 'full'},
            {
                path: 'supply-list',
                title: 'Swiss-Soft Time',
                component: TimeAppWorkSupplyListComponent,
            },
            {path: 'supply-entry', redirectTo: 'supply-entry/', pathMatch: 'full'},
            {
                path: 'supply-entry/:supplyEntryID',
                title: 'Swiss-Soft Time',
                component: TimeAppWorkSupplyEntryComponent,
            }
        ]
    },
    {
        path: 'timeapp/settings',
        canActivate: [AuthenticatedGuard, TimeAppLicenseGuard],
        component: SettingsComponent,
    },
    {
        path: 'timeapp/workTimes',
        canActivate: [AuthenticatedGuard, TimeAppLicenseGuard],
        component: SavedWorktimesComponent,
    },
    {
        path: 'timeapp/share-order',
        canActivate: [AuthenticatedGuard, TimeAppLicenseGuard],
        component: ShareOrderComponent,
    },
    {
        path: 'timeapp/share-emp-order',
        canActivate: [AuthenticatedGuard, TimeAppLicenseGuard],
        component: ShareEmpOrderComponent,
    },
    {
        path: 'timeapp/scan',
        canActivate: [AuthenticatedGuard, TimeAppLicenseGuard],
        component: ScanComponent,
    },
    {
        path: 'timeapp/edit-img',
        canActivate: [AuthenticatedGuard, TimeAppLicenseGuard],
        component: EditImgComponent,
    },
    {
        path: 'adressen-mobile/:id',
        canActivate: [AuthenticatedGuard, NavigatorLicenseGuardGuard],
        component: AdressenMobileComponent,
    },
    {
        path: 'objekte-mobile/:id',
        canActivate: [AuthenticatedGuard, NavigatorLicenseGuardGuard],
        component: ObjekteMobileComponent,
    },
    {
        path: 'adressen-mobile',
        canActivate: [AuthenticatedGuard, NavigatorLicenseGuardGuard],
        component: AdressenMobileComponent,
    },
    {
        path: 'objekte-mobile',
        canActivate: [AuthenticatedGuard, NavigatorLicenseGuardGuard],
        component: ObjekteMobileComponent,
    },
    {
        path: 'termin-mobile',
        canActivate: [AuthenticatedGuard, NavigatorLicenseGuardGuard],
        component: TerminMobileComponent,
    },
    {
        path: 'dashboard-mobile',
        canActivate: [AuthenticatedGuard, NavigatorLicenseGuardGuard],
        component: DashboardMobileComponent,
        children: [
            {
                path: 'meineaufgabenmobile',
                component: PersonalTasksComponent,
            },
            {
                path: 'meinenotizenmobile',
                component: MeineNotizenComponent,
            },
            {
                path: 'meineterminemobile',
                component: MeineTermineComponent,
            },
        ]
    },
    {
        path: 'appeinstellungen-mobile',
        canActivate: [AuthenticatedGuard],
        component: AppEinstellungenMobileComponent,
    },
    {
        path: 'dbcontrol-mobile',
        canActivate: [AuthenticatedGuard],
        component: DBControlComponent,
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {
}
